import { Grid, Typography } from "@mui/material";
import { Box } from "@mui/system";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import CustomButton from "../../common/components/CustomButton/CustomButton";
import CustomTextField from "../../common/components/CustomTextField/CustomTextField";
import CustomModal from "../../common/Modals/CustomModal/CustomModal";
import ModalHeader from "../../common/Modals/CustomModal/ModalHeader";
import { fonts, themes } from "../../common/themes/themes";

const ResetPasswordPresenter = () => {
  const [openModal, setOpenModal] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  return (
    <CustomModal isModalOpen={openModal} modalHeight="554px" modalWidth="400px">
      <Grid
        container
        spacing={2}
        style={{
          marginTop: "10px",
        }}
      >
        <Grid item xs={12}>
          <CustomTextField
            type="password"
            label="New Password"
            value={newPassword}
            onChange={(e: any) => setNewPassword(e.target.value)}
            InputProps={{
              endAdornment: (
                <i
                  className={`las ${showPassword ? 'la-eye-slash' : 'la-eye'} text-[#7C0E6F] text-2xl`}
                  onClick={() => setShowPassword(!showPassword)}
                  style={{ 
                    cursor: 'pointer' , 
                    color: "#7C0E6F",
                    fontSize: '1.5rem'
                  }}
                ></i>
              ),
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <CustomTextField
            type="password"
            label="Confirm Password"
            value={confirmPassword}
            onChange={(e: any) => setConfirmPassword(e.target.value)}
          />
        </Grid>
        <Grid
          item
          xs={12}
          style={{
            textAlign: "center",
          }}
        >
          <CustomButton
            buttonText={"RESET PASSWORD"}
            onClickSubmit={() => alert()}
            backgroundColor={themes.primary}
            borderRadius={"0.3em"}
            color="white"
            width="250px"
          />
        </Grid>
        <Grid
          item
          xs={12}
          style={{
            textAlign: "center",
          }}
        >
          <Typography
            style={{
              fontFamily: fonts.fontFamily,
              color: themes.greyDefault_500,
              cursor: "pointer",
            }}
            onClick={() => navigate({ pathname: "/login" })}
          >
            Back to Login
          </Typography>
        </Grid>
      </Grid>
    </CustomModal>
  );
};

export default ResetPasswordPresenter;
